import { doesWorkflowRejectCodeExist } from '@tassat/common-definitions';
import { IFormValues } from '@tassat/forms/src/WalletUserMappingForm/types';

import Worker from 'Lib/worker/PrimusWorkerWrapper';

export const submitWalletUserMappingForm = async (values: IFormValues, opts: {
    accountId: string;
    setSubmitError: React.Dispatch<React.SetStateAction<string>>;
    onClose: () => void;
}): Promise<void> => {
    const {
        accountId,
        setSubmitError,
        onClose
    } = opts;

    const errors = [];

    try {
        values.Mappings.forEach(async (mapping) => {
            let response;

            if (Object.keys(mapping.User.refData?.userAccount).length > 0) {
                response = await Worker.getInstance()
                    .updateUserAccount({
                        UserId: mapping.User.value,
                        AccountId: accountId,
                        ClientRoleId: mapping.Role,
                        WireRoleId: mapping.User.refData.userAccount.WireRoleId,
                        UserAccountId: mapping.User.refData.userAccount.UserAccountId,
                        IsFavorite: mapping.User.refData.userAccount.Isfavorite,
                        IsDeleted: mapping.User.refData.userAccount.IsDeleted
                    });
            } else {
                response = await Worker.getInstance()
                    .createUserAccount({
                        UserId: mapping.User.value,
                        AccountId: accountId,
                        ClientRoleId: mapping.Role
                    });
            }

            if (response.data && (response.data.Status === 49 || doesWorkflowRejectCodeExist(response.data.Status))) {
                errors.push(mapping.User.label);
            }
        });

        if (errors.length > 0) {
            setSubmitError(`Could not map user(s) to account: ${errors.join(', ')}`);
        } else {
            onClose();
        }
    } catch (error) {
        setSubmitError('Something went wrong');
    }
};